<router-outlet></router-outlet>
<ng-http-loader [backdropBackgroundColor]="'#000'" [opacity]="'.4'" [backgroundColor]="'#74E291'"
  [spinner]="spinkit.skThreeBounce"></ng-http-loader>
